export const FETCH_ORDERPAY_ACCOUNT_INFO = 'fetchOrderPayAccountInfo';
export const CANCEL_ORDERPAY_ACCOUNT = 'cancelOrderPayAccount';
